// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonLoader_skeleton__V+i72","medium":"SkeletonLoader_medium__ixI0e","small":"SkeletonLoader_small__hsDDU"};